import { MarketingPreferencesService } from './model/squareup/buyerportal/preference/marketing';
import rpc from './rpc';

const marketingPreferencesClient = MarketingPreferencesService.create(rpc());

export default marketingPreferencesClient;
